import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import EmpionLogo from '../../../../../components/EmpionLogoAnimation/EmpionLogo';
import {ProgressBar} from '../../../../../components/ProgressBar/ProgressBar';
import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {empionOrange} from '../../../../../layouts/theme/EmpionColors';
import {MatchText} from '../../../../../types/shared-recruiting-types';

interface Props {
  percent: number;
  isCultureTypeMissing?: boolean;
  matchText: MatchText;
  applicantName?: string;
  detailedCardView?: boolean;
}

export const MatchLevel = ({percent, matchText, applicantName, detailedCardView, isCultureTypeMissing}: Props) => {
  const lang = useContext(LanguageContext);
  const {t} = useTranslation();

  const getText = (percent: number) => {
    if (percent < 70) {
      return matchText.low[lang];
    }
    if (percent < 85) {
      return matchText.mid[lang];
    }

    return matchText.high[lang];
  };

  const displayText = isCultureTypeMissing
    ? t('applicantDashboard.matchDetailsView.cultureFitDetails.missingCultureType')
    : `${applicantName || ''} ${getText(percent)}`;

  return (
    <Grid container width={'100%'} justifyContent='center' alignItems='center' flexDirection='column'>
      <EmpionLogo size='24px' sx={{marginBottom: '8px'}} />
      <Typography variant='h4' paddingBottom='8px' textAlign='center' sx={{color: empionOrange[70]}}>
        {displayText}
      </Typography>
      <ProgressBar percent={percent} detailedCardView={detailedCardView} />
    </Grid>
  );
};
